import React from 'react';
import PropTypes from 'prop-types';
import { CompanyTabsWrapper } from '../Tabs';

const CompanyWrapper = ({
  children,
  profile,
}) => (
  <>
    <CompanyTabsWrapper profile={profile} />
    {children}
  </>
);

CompanyWrapper.propTypes = {
  profile: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};

export default CompanyWrapper;
